import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  static targets = [
    "form",
    "ticket",
    "usedCount",
    "purchasedOn",
    "expirationMode",
    "expiresOn",
    "expirationPreview",
    "expirationControls"
  ]

  connect() {
    this.updateTicketSettings()
  }

  updateTicketSettings() {
    const option = this.ticketTarget.selectedOptions[0]
    const totalCount = Number(option?.dataset.initialCount || 0)
    this.usedCountTarget.max = totalCount
    if (Number(this.usedCountTarget.value) > totalCount) this.usedCountTarget.value = totalCount

    const noExpiration = option?.dataset.noExpiration === "true"
    this.expirationControlsTarget.classList.toggle("d-none", noExpiration)
    this.expirationModeTargets.forEach(input => { input.disabled = noExpiration })
    this.expiresOnTarget.disabled = noExpiration
    if (noExpiration) {
      this.expiresOnTarget.value = ""
      this.expirationPreviewTarget.textContent = this.expirationPreviewTarget.dataset.noExpirationText
      return
    }

    this.updateExpirationMode()
  }

  updateExpirationMode() {
    const mode = this.expirationModeTargets.find(input => input.checked)?.value || "auto"
    const manual = mode === "manual"
    this.expiresOnTarget.readOnly = !manual
    this.expiresOnTarget.classList.toggle("bg-light", !manual)

    if (!manual) this.calculateExpiration()
  }

  calculateExpiration() {
    const option = this.ticketTarget.selectedOptions[0]
    const purchasedOn = this.purchasedOnTarget.value
    if (!option?.value || !purchasedOn) {
      this.expiresOnTarget.value = ""
      this.expirationPreviewTarget.textContent = ""
      return
    }

    const value = Number(option.dataset.validityValue || 0)
    const unit = option.dataset.validityUnit
    if (!value || !unit) {
      this.expiresOnTarget.value = ""
      this.expirationPreviewTarget.textContent = ""
      return
    }

    const result = this.addPeriod(purchasedOn, value, unit)
    this.expiresOnTarget.value = result
    this.expirationPreviewTarget.textContent =
      `${this.expirationPreviewTarget.dataset.calculatedLabel}: ${result.replaceAll("-", "/")}`
  }

  submit() {
    if (!this.formTarget.checkValidity()) {
      this.formTarget.reportValidity()
      return
    }
    if (this.submitting) return

    this.submitting = true
    const modal = bootstrap.Modal.getInstance(this.element)
    if (modal && this.element.classList.contains("show")) {
      this.element.addEventListener("hidden.bs.modal", () => {
        this.formTarget.requestSubmit()
      }, { once: true })
      modal.hide()
    } else {
      this.formTarget.requestSubmit()
    }
  }

  addPeriod(dateString, value, unit) {
    const [year, month, day] = dateString.split("-").map(Number)
    const date = new Date(Date.UTC(year, month - 1, day))

    if (unit === "days") {
      date.setUTCDate(date.getUTCDate() + value)
    } else {
      const months = unit === "years" ? value * 12 : value
      date.setUTCDate(1)
      date.setUTCMonth(date.getUTCMonth() + months)
      const lastDay = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 0)).getUTCDate()
      date.setUTCDate(Math.min(day, lastDay))
    }

    return date.toISOString().slice(0, 10)
  }
}
